export default __webpack_public_path__ + "static/media/Kristin400.fde29fb0.jpg";